export const protectedRoutes = [
  '/cabinet/profile',
  '/cabinet/profile?[param]',
  '/cabinet/gallery/add',
  '/cabinet/gallery',
  '/cabinet/gallery/edit/[id]',
  '/cabinet/deals',
  '/cabinet/balance',
  '/collection/edit/[slug]',
  '/collection/create',
];